import { useSyncExternalStore } from 'react';

/**
 * Whether the device believes it has a network.
 *
 * On a shop floor this matters more than it does at a desk: the Wi-Fi drops
 * behind steel, and an operator who does not know they are offline will keep
 * tapping Pass and assume it is being recorded. Nothing is queued for later —
 * a check that did not reach Odoo did not happen, and saying otherwise would
 * be worse than saying nothing.
 *
 * `navigator.onLine` only knows about the local link, so it can report a
 * connection that goes nowhere. It is a floor, not a guarantee: a request that
 * fails anyway still surfaces its own error.
 */
function subscribe(cb: () => void): () => void {
  window.addEventListener('online', cb);
  window.addEventListener('offline', cb);
  return () => {
    window.removeEventListener('online', cb);
    window.removeEventListener('offline', cb);
  };
}

export function useOnline(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  );
}
